import React from 'react';

import { TableCell, TableHeaderCell } from '@hcs/design-system';
import { TableCellProps, TableHeaderCellProps } from '@hcs/types';
import { formatMissing } from '@hcs/utils';

import { DATA_HC_NAME_ORDERS_TABLE_CELL } from '../../../constants';
import { OmOrder } from '../../../types';

import { OrdersTableCellsDisplayProps } from '.';

// eslint-disable-next-line react-refresh/only-export-components
const Display = ({
  order,
}: OrdersTableCellsDisplayProps): JSX.Element | null => {
  return (
    <div data-hc-name={`${DATA_HC_NAME_ORDERS_TABLE_CELL}-owner-email`}>
      {formatMissing(order?.ownerEmail)}
    </div>
  );
};

// eslint-disable-next-line react-refresh/only-export-components
const HeaderCell = ({ ...tableHeaderCellProps }) => {
  return (
    <TableHeaderCell {...tableHeaderCellProps}>Created By</TableHeaderCell>
  );
};

const defaultHeaderCellProps: Partial<TableHeaderCellProps> = {
  isTableHeaderCell: true,
};

HeaderCell.defaultProps = defaultHeaderCellProps;

export type OrdersTableCellProps = TableCellProps & OmOrder;

// eslint-disable-next-line react-refresh/only-export-components
const ContentCell = ({ order, ...tableCellProps }: { order: OmOrder }) => {
  return (
    <TableCell {...tableCellProps}>
      <Display order={order} />
    </TableCell>
  );
};

const defaultContentProps: Partial<TableCellProps> = {
  isTableCell: true,
};

ContentCell.defaultProps = defaultContentProps;

export const ORDER_OWNER_EMAIL_CONFIG = {
  HeaderCell,
  ContentCell,
  label: 'Created By',
};
